import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
/**
 * Service for fetching CAU (Common Area Unit) designation options
 */
export default class FloorPlanCAUDesignationService {
  /**
   * Fetches all available CAU designation types
   * @returns {Promise<Array>} Array of CAU designation objects with id and name
   * Example: [{ id: "uuid-1", name: "Manager" }, { id: "uuid-2", name: "Maintenance" }, ...]
   */
  async getCAUDesignations() {
    const requestOptions = {
      method: 'GET',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(`${apiURL}/floorPlan/cauDesignations`, requestOptions);
  }
}
